module.exports = __webpack_public_path__ + "img/48ne.39011621.svg";